import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useOrg } from './OrgContext';
import { useAuth } from '../auth/AuthContext';
import Icon from '../components/Icon';

const ALL_DIVISIONS = ['GFM', 'GPM', 'Fleet', 'Assets'];

export default function OrgPicker() {
  const nav = useNavigate();
  const { setOrg } = useOrg();
  const { user } = useAuth();

  const allowed = useMemo(() => {
    if (Array.isArray(user?.permissions) && user.permissions.length) {
      const p = user.permissions.map(x => String(x).toLowerCase());
      return ALL_DIVISIONS.filter(d => p.includes(d.toLowerCase()));
    }
    const scopes = Array.isArray(user?.scopes) ? user.scopes : [];
    const has = (prefix) => scopes.some(s => s.startsWith(prefix));
    const divs = [];
    if (has('gfm:'))    divs.push('GFM');
    if (has('gpm:'))    divs.push('GPM');
    if (has('fleet:'))  divs.push('Fleet');
    if (has('assets:')) divs.push('Assets');
    return divs.length ? divs : ALL_DIVISIONS;
  }, [user]);

  const pick = (o) => { setOrg(o); localStorage.setItem('org', o); nav('/dashboard'); };

  return (
    <div className="container">
      <div className="card org-card">
        <div className="org-toolbar">
          <div>
            <h1>Choose a division</h1>
            {user?.username && <p className="org-sub">Signed in as <strong>{user.username}</strong></p>}
          </div>
          <Link to="/change-password" className="btn secondary small">
            Change password
          </Link>
        </div>

        <div className="org-grid">
          {allowed.map(d => (
            <button key={d} className="org-tile" onClick={() => pick(d)}>
              <span className="org-tile-name">{d}</span>
              <span className="org-tile-arrow"><Icon name="arrowRight" size={18} /></span>
            </button>
          ))}
        </div>

        {allowed.length === 0 && (
          <div className="alert error mt-16">
            Your account has no division access. Please contact an administrator.
          </div>
        )}
      </div>
    </div>
  );
}
